import CreateFormWizard from './CreateFormWizard';

const CreateForm = () => <CreateFormWizard/>;

export default CreateForm;
